import React from "react";

const DeleteIcon = () => {
  return (
    <>
      <svg width="14.5" height="16.001" viewBox="0 0 14.5 16.001">
        <g
          id="Group_351"
          data-name="Group 351"
          transform="translate(1085.871 211.629) rotate(90)"
        >
          <g
            id="Icon_feather-trash"
            data-name="Icon feather-trash"
            transform="translate(-214.129 1089.871) rotate(-90)"
          >
            <path
              id="Path_2534"
              data-name="Path 2534"
              d="M4.5,9H18"
              transform="translate(0 -3)"
              fill="none"
              stroke="#e65151"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_2535"
              data-name="Path 2535"
              d="M18,6V16.5A1.5,1.5,0,0,1,16.5,18H9a1.5,1.5,0,0,1-1.5-1.5V6M9.75,6V4.5A1.5,1.5,0,0,1,11.25,3h3a1.5,1.5,0,0,1,1.5,1.5V6"
              transform="translate(-1.5)"
              fill="none"
              stroke="#e65151"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default DeleteIcon;
